/** Claves canónicas de tipo de regla (independientes del idioma). */
export const RULE_TYPE = {
	SHIFT: 'shift',
	TIME_TYPE: 'time_type',
	CLOCKED_HOURS: 'clocked_hours',
	CALCULATED: 'calculated',
};

const RULE_TYPE_ALIASES = {
	// Turno
	Turno: RULE_TYPE.SHIFT,
	Shift: RULE_TYPE.SHIFT,
	Torn: RULE_TYPE.SHIFT,
	SHIFT: RULE_TYPE.SHIFT,
	TURNO: RULE_TYPE.SHIFT,
	// Tipo de tiempo
	'Tipo de tiempo': RULE_TYPE.TIME_TYPE,
	'Time type': RULE_TYPE.TIME_TYPE,
	'Time Type': RULE_TYPE.TIME_TYPE,
	'Tipus de temps': RULE_TYPE.TIME_TYPE,
	TIME_TYPE: RULE_TYPE.TIME_TYPE,
	// Horas fichadas
	'Horas de trabajo fichadas': RULE_TYPE.CLOCKED_HOURS,
	'Clocked work hours': RULE_TYPE.CLOCKED_HOURS,
	'Clocked working hours': RULE_TYPE.CLOCKED_HOURS,
	CLOCKED_WORK_HOURS: RULE_TYPE.CLOCKED_HOURS,
	// Calculada
	Calculada: RULE_TYPE.CALCULATED,
	Calculated: RULE_TYPE.CALCULATED,
	CALCULATED: RULE_TYPE.CALCULATED,
};

const NORMALIZED_ALIASES = Object.entries(RULE_TYPE_ALIASES).reduce((acc, [alias, key]) => {
	acc[alias.toLowerCase()] = key;
	return acc;
}, {});

function resolveStaticRuleTypeKey(type) {
	const direct = RULE_TYPE_ALIASES[type];
	if (direct) return direct;

	return NORMALIZED_ALIASES[String(type).toLowerCase()] || null;
}

function resolveRuleTypeKeyFromApi(type, ruleTypes) {
	if (!type || !ruleTypes?.length) return null;

	const item = ruleTypes.find(
		(t) => t.name === type || String(t.id) === String(type)
	);
	if (!item) return null;

	return resolveStaticRuleTypeKey(item.name)
		|| (item.id != null ? resolveStaticRuleTypeKey(String(item.id)) : null);
}

export function getRuleTypeKey(type, ruleTypes) {
	if (!type) return null;

	const staticKey = resolveStaticRuleTypeKey(type);
	if (staticKey) return staticKey;

	return resolveRuleTypeKeyFromApi(type, ruleTypes);
}

export function isShiftRuleType(type, ruleTypes) {
	return getRuleTypeKey(type, ruleTypes) === RULE_TYPE.SHIFT;
}

export function isTimeTypeRuleType(type, ruleTypes) {
	return getRuleTypeKey(type, ruleTypes) === RULE_TYPE.TIME_TYPE;
}

export function isClockedHoursRuleType(type, ruleTypes) {
	return getRuleTypeKey(type, ruleTypes) === RULE_TYPE.CLOCKED_HOURS;
}

export function isCalculatedRuleType(type, ruleTypes) {
	return getRuleTypeKey(type, ruleTypes) === RULE_TYPE.CALCULATED;
}

export function supportsDayTypeFilter(type, ruleTypes) {
	const key = getRuleTypeKey(type, ruleTypes);
	return key === RULE_TYPE.SHIFT
		|| key === RULE_TYPE.TIME_TYPE
		|| key === RULE_TYPE.CLOCKED_HOURS;
}

export function isContractRuleType(type, ruleTypes) {
	return isShiftRuleType(type, ruleTypes) || isTimeTypeRuleType(type, ruleTypes);
}
